// extracted by mini-css-extract-plugin
module.exports = {"logo":"RFhPj","link":"zC6A8","icon":"wp839"};